import { NotificationContext, NotificationContextType } from "modules/notifications/src/notification-context"
import { useContext } from "react"

export function useNotifications (): NotificationContextType {
    return useContext( NotificationContext )
}
